import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { scheduleJobToActiveCrew } from '../../../redux/calendar';
import { updateSearchCriteria, searchCustomers } from '../../../redux/searchJobs';
import AvailableJobs from './AvailableJobs';

const colors = createSelector(
  (state) => state.settings.color,
  (state) => state.dropdowns,
  (colorMode, { jobStatuses, jobTypes, offices }) => {
    switch (colorMode) {
      case 'jobStatus':
        return jobStatuses;
      case 'office':
        return offices;
      default:
        return jobTypes;
    }
  }
);

const jobs = createSelector(
  (state) => state.searchJobs.jobs,
  (state) => state.settings.color,
  colors,
  (jobs, colorMode, colors) => jobs.map((j) => {
    let color = null;
    switch (colorMode) {
      case 'jobType':
        const jobType = colors.find((jobType) => jobType.name === j.jobType);
        color = jobType ? jobType.color : null;
        break;
      case 'office':
        const office = colors.find((office) => j.office && office.id === j.office.id);
        color = office ? office.color : null;
        break;
      case 'salesperson':
        const salesperson = j.salesperson;
        color = salesperson ? salesperson.calendarColor : null;
        break;
      default:
        const jobStatus = colors.find((jobStatus) => jobStatus.value === j.status);
        color = jobStatus ? jobStatus.color : null;
        break;
    }
    return { ...j, color };
  })
)

const mapStateToProps = (state) => ({
  ...state.searchJobs,
  activeCrew: state.calendar.activeCrew,
  jobs: jobs(state),
  detailEnabled: state.settings.detailEnabled,
  dropdowns: state.dropdowns,
  financialEnabled: state.settings.financialEnabled,
  locationEnabled: state.settings.locationEnabled
});

const mapDispatchToProps = {
  onCustomerSearch: searchCustomers,
  onJobClick: scheduleJobToActiveCrew,
  onFormUpdate: updateSearchCriteria
};

export default connect(mapStateToProps, mapDispatchToProps)(AvailableJobs);
